export default "__VITE_ASSET__DcsP3qE7__"